// Story BP-3: feature gates declarativos (OQ6=híbrido Pax).
// SSOT do `can(feature)` combina 2 fontes:
//   1. FEATURE_GATES (spec/fallback compile-time, type-safe)
//   2. plans.features JSONB no DB (runtime override se presente — flexibilidade pra Morgan)
// Hook combina com OR: `FEATURE_GATES[f].includes(tier) || features[f] === true`.

import type { FeatureKey, LimitKey, PlanTier } from './types';

/**
 * Declarative map: which tiers grant each binary feature.
 * Compile-time SSOT; Exhaustive pra FeatureKey via Record type.
 */
export const FEATURE_GATES: Record<FeatureKey, PlanTier[]> = {
  'pdf.individual': ['pro', 'business'],
  'pdf.report': ['business'],
  'md.export': ['free', 'pro', 'business'], // Story saas-1.18 D5 — adoption funnel; Morgan/Pax may flip via plans.features JSONB.
  webhook: ['pro', 'business'], // Pro: 3 webhooks (cap via withinLimit('webhooks_max', count))
  custom_logo: ['pro', 'business'],
  remove_watermark: ['pro', 'business'],
  email_notifications: ['pro', 'business'],
  partial_responses: ['pro', 'business'],
  redirect_url: ['pro', 'business'],
} as const;

/**
 * Numeric limit keys — used by `withinLimit(name, currentCount)`.
 * Default caps documented per OQ1 BP-1 schema; values live in `plans.limits` JSONB at runtime.
 * -1 convention = unlimited.
 */
export const LIMITS_KEYS: LimitKey[] = [
  'forms_max',
  'responses_per_month',
  'fields_per_form',
  'webhooks_max',
  'seats_max',
];

/**
 * Fallback limits if `plans.limits` JSONB is missing (defensive, should never happen in prod).
 * Mirror dos valores canônicos do EPIC.md tier matrix.
 */
export const DEFAULT_LIMITS: Record<PlanTier, Record<LimitKey, number>> = {
  free: {
    forms_max: 3,
    responses_per_month: 100,
    fields_per_form: 20,
    webhooks_max: 0,
    seats_max: 1,
    file_upload_bytes: 1_048_576, // 1 MB (BP-7 OQ1 Pax)
  },
  pro: {
    forms_max: 25,
    responses_per_month: 2000,
    fields_per_form: -1,
    webhooks_max: 3,
    seats_max: 1,
    file_upload_bytes: 5_242_880, // 5 MB (BP-7 OQ1 Pax)
  },
  business: {
    forms_max: -1,
    responses_per_month: -1,
    fields_per_form: -1,
    webhooks_max: -1,
    seats_max: 5,
    file_upload_bytes: 20_971_520, // 20 MB (BP-7 OQ1 Pax)
  },
};
